import { c as _c } from "react/compiler-runtime";
import { SnackbarKey } from 'notistack';
import { IconButton } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useSnackbar } from 'notistack';
import { JSX } from 'react';
const Snackbar = t0 => {
  const $ = _c(6);
  const {
    id
  } = t0;
  const {
    closeSnackbar
  } = useSnackbar();
  let t1;
  if ($[0] !== closeSnackbar || $[1] !== id) {
    t1 = () => closeSnackbar(id);
    $[0] = closeSnackbar;
    $[1] = id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CloseRoundedIcon />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <IconButton onClick={t1}>{t2}</IconButton>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default Snackbar;